import { domainNameDesv, domainNameProd } from './system';

export let urlsServices = {};

export let ambiente = null;

if (window.location.hostname.indexOf(domainNameDesv) > -1) {
  //ambiente = 'PROD';
}

if (window.location.hostname.indexOf(domainNameProd) > -1 || ambiente === 'PROD') {
  urlsServices.GETWAY = 'https://csmpmws.ssp.go.gov.br/';
  urlsServices.SIGUWS = 'https://siguws.ssp.go.gov.br/';
  urlsServices.LEGADOWS = 'https://legadows.ssp.go.gov.br/';
  urlsServices.SSOWS = 'https://ssows.ssp.go.gov.br/';
  urlsServices.FILEWS = 'https://filews.ssp.go.gov.br/';
  ambiente = 'PROD';
} else {
  urlsServices.GETWAY = 'https://csmpmws-h.ssp.go.gov.br/';
  urlsServices.SIGUWS = 'https://siguws-h.ssp.go.gov.br/';
  urlsServices.LEGADOWS = 'https://legadows-h.ssp.go.gov.br/';
  urlsServices.SSOWS = 'https://ssows-h.ssp.go.gov.br/';
  urlsServices.FILEWS = 'https://filews-h.ssp.go.gov.br/';
  urlsServices.WEBSOCKET = 'http://csmpmws-h.ssp.go.gov.br/ws';
  ambiente = 'HOMO';

  if (window.location.hostname.indexOf(domainNameDesv) > -1) {
    urlsServices.GETWAY = 'http://localhost:8066/';
    urlsServices.WEBSOCKET = 'http://localhost:8066/ws';
    //urlsServices.LEGADOWS = 'http://localhost:8083/';
    //urlsServices.GETWAY = 'https://csmpmws-h.ssp.go.gov.br/';
    //urlsServices.WEBSOCKET = 'https://csmpmws-h.ssp.go.gov.br/ws';
  }
}
